import moment from "moment";

// Calcula el tiempo que le queda a una cuenta antes de vencer.
//
// Devuelve:
//   text  -> texto corto listo para mostrar ("4 months left", "Expired 3 days ago")
//   level -> "expired" | "critical" (7 dias o menos) | "warning" (30 o menos)
//            | "ok" | "none" (sin fecha valida)
//   days  -> dias restantes (negativo si ya vencio), o null si no hay fecha
export const getRemaining = (dueDate) => {
  if (!dueDate) {
    return { text: "No expiry date", level: "none", days: null };
  }

  const end = moment(dueDate);
  if (!end.isValid()) {
    return { text: "Invalid date", level: "none", days: null };
  }

  const now = moment();
  const days = end.diff(now, "days");

  if (end.isBefore(now)) {
    const dv = Math.abs(days);
    return {
      text: `Expired ${dv} day${dv === 1 ? "" : "s"} ago`,
      level: "expired",
      days,
    };
  }

  // Cuando queda poco se dan los dias exactos: humanize() redondea tanto que
  // "45 dias" y "30 dias" se leerian igual ("a month") con colores distintos.
  const text =
    days === 0
      ? "Expires today"
      : `${days} day${days === 1 ? "" : "s"} left`;

  if (days <= 7) return { text, level: "critical", days };
  if (days <= 30) return { text, level: "warning", days };
  return { text, level: "ok", days };
};
